import { z } from 'zod';

import { formatZodErrors } from './formatZodErrors';
import type { FormattedErrors } from './formatZodErrors';

export function formatValidationErrors(
  result: z.SafeParseReturnType<object, object>
): FormattedErrors | null {
  if (!('error' in result)) {
    return null;
  }

  const customErrors = new z.ZodError(
    result.error.errors.map((error) => {
      if (error.code === 'invalid_union') {
        const fieldName = error.path[error.path.length - 1] as string;
        const formattedFieldName = fieldName
          .replace(/([A-Z])/g, ' $1')
          .trim()
          .toLowerCase();
        return {
          ...error,
          message: `Please select a value for ${formattedFieldName}`,
          code: error.code,
          path: error.path,
        };
      }
      if (error.code === 'invalid_type') {
        const fieldName = error.path[error.path.length - 1] as string;
        const formattedFieldName = fieldName
          .replace(/([A-Z])/g, ' $1')
          .trim()
          .toLowerCase();
        return {
          ...error,
          message: `${formattedFieldName.charAt(0).toUpperCase() + formattedFieldName.slice(1)} is required`,
          code: error.code,
          path: error.path,
        };
      }
      return error;
    })
  );

  return formatZodErrors(customErrors);
}
